import React from "react";
import check from "../../_assets/img/clipart/ic-check.png";
import { useState } from "react";

function CardPaket1({ setCardPaket1, popHarga }) {
  const [orderButton, setOrderButton] = useState(false);

  const [tema, setTema] = useState({
    namaTema: "",
  });

  const [request, setRequest] = useState({
    tema: "",
  });

  const handleChange = (e) => {
    let data = { ...request };
    data[e.target.name] = e.target.value;
    setRequest(data);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setTema({ namaTema: request.tema });
  };

  return (
    <div
      className="max-w-lg h-min fixed  m-auto top-4 bottom-0 left-0 right-0 z-10 shadow-xl"
      data-aos="zoom-in"
      data-aos-duration="200"
    >
      <div className="bg-[#890025] w-full h-auto py-2 flex items-center pl-3 justify-between">
        <h3 className="text-white text-md md:text-xl lg:text-2xl font-semibold">
          Pilihan Paket Kamu : UR 1
        </h3>
        <button
          onClick={() => {
            popHarga.classList.remove("opacity-25");
            setCardPaket1(false);
          }}
          className="z-20"
        >
          <i className="bi bi-x transition-all duration-300 text-2xl md:text-3xl lg:text-5xl text-white"></i>
        </button>
      </div>
      <div className="card rounded-none">
        <div className="card-body">
          <div className="bg-[#890025] w-min -ml-4 pl-5 pr-2 text-white">
            <h2 className="lg:text-2xl md:text-xl text-md">Include:</h2>
          </div>
          <ul className="my-3">
            <li className="flex items-center my-2 md:my-3">
              <img
                className="w-5 md:w-8 mr-2 md:mr-3"
                src={check}
                alt="check"
              />
              <p className="lg:text-xl md:text-lg text-sm">
                Undangan Video Wedding
              </p>
            </li>
            <li className="flex items-center my-2 md:my-3">
              <img
                className="w-5 md:w-8 mr-2 md:mr-3"
                src={check}
                alt="check"
              />
              <p className="lg:text-xl md:text-lg text-sm">
                Wedding Letter Card
              </p>
            </li>
            <li className="flex items-center my-2 md:my-3">
              <img
                className="w-5 md:w-8 mr-2 md:mr-3"
                src={check}
                alt="check"
              />
              <p className="lg:text-xl md:text-lg text-sm">
                Wedding Save The Date
              </p>
            </li>
          </ul>
          <hr />
          <form onSubmit={handleSubmit}>
            <div className="flex justify-between mt-2 items-center">
              <div>
                <input
                  type="text"
                  name="tema"
                  className="w-2/3 md:w-1/2 lg:w-max md:p-1 mr-1 border-2 rounded-md focus:outline-none"
                  required
                  value={request.tema}
                  onChange={handleChange}
                />
                <button
                  onClick={() => {
                    if (request.tema === "") {
                      setOrderButton(false);
                    } else {
                      setOrderButton(true);
                    }
                  }}
                  className="py-1 px-2 text-center w-min mx-auto md:text-lg text-white font-semibold rounded-md bg-green-500"
                >
                  OK
                </button>
              </div>
              <h2 className="lg:text-2xl md:text-xl text-md text-right text-[#890025] font-semibold">
                <span className="text-gray-900">Total : </span>Rp.60.000
              </h2>
            </div>
          </form>
          <p className="btn md:text-md text-sm pl-0">
            Request Tema :{" "}
            <span className="font-semibold text-[#890025]">
              {tema.namaTema}
            </span>
          </p>
        </div>
        {orderButton ? (
          <a
            className="bg-green-500 px-3 py-2 rounded-md w-1/2 text-center mx-auto mb-3"
            data-aos="zoom-in"
            href={`https://wa.me/6283815204904?text=Hallo%20kak,%20saya%20mau%20order%20paket%20*UR1*%20dengan%20tema%20${tema.namaTema}`}
          >
            <i class="bi bi-whatsapp text-white font-semibold"> Order</i>
          </a>
        ) : null}
      </div>
    </div>
  );
}

export default CardPaket1;
